<template>
  <header>
    <div class="header">
      <img class="logo" :src="`${this.logo}`" alt="logo 4cadia" />

      <input id="dropdown" class="hamburguer-check" type="checkbox">
      <label for="dropdown" class="hamburguer-label">
        <div class="menu-hamb">
          <span class="hamburguer"></span>
        </div>
      </label>
      <ul class="header-itens">
        <li><a href="../">Home</a></li>
        <li><a href="../foundation">Foundation</a></li>
        <li><a href="../factory">Factory</a></li>
        <li><a href="../governance">Governance</a></li>
        <li><a href="#section-contact">Contact</a></li>
      </ul>
    </div>
  </header>
</template>

<script>
import contentService from '../api/contentService'
import BaseMenu from '@/components/BaseMenu'

export default {
  name: 'Header',
  components: {
    'v-menu': BaseMenu
  },
  data () {
    return {
      showMenu: false,
      menu: [],
      logo: '',
      title: ''
    }
  },
  methods: {
    toggleShowMenu: function (value) {
      this.showMenu = !this.showMenu
    },
    handleMenuClick: function (link) {
      if (this.showMenu) this.toggleShowMenu()
    }
  },
  mounted: function () {
    contentService('header').then((response) => {
      this.menu = response.data.menu
      this.logo = response.data.logo
      this.title = response.data.title
    })
  }
}
</script>

<style scoped>
  /* Header - section style */
  header {
    width: 100%;
    background: #071D49;
  }

  a {
    font-family: "Noto Sans", Arial, sans-serif;
    text-decoration: none;
    color: inherit;
  }

  li {
    list-style-type: none;
  }

  .header {
    padding: 0 30px;
    display: flex;
    justify-content: space-between;
    height: 50px;
  }

  .header-itens {
    margin: 16px 0px;
  }

  .header-itens li {
    display: inline;
    align-content: center;
    text-align: center;
  }

  .header-itens a {
    color: #FFFFFF;
    font-size: 16px;
    margin: auto 10px;
    line-height: 18.4px;
  }

  .header-itens a:hover {
    color: #009CDE;
    transition: 0.3s;
  }

  .hamburguer-check {
    display: none;
  }

/* Media Mobile */
@media (max-width: 768px) {
  .header_menu {
    flex-direction: row-reverse;
    align-content: center;
  }
  .header_menu .menu-hamburguer {
    display: block;
    height: auto;
    z-index: 3;
    margin-left: 10px;
    background-image: url('../assets/icons/menu.svg');
  }
  .header_menu.open .menu {
    right: 0;
  }
  .header_menu.open .menu-hamburguer {
    background-image: url('../assets/icons/close.svg');
  }
  .header {
    display: flex;
    align-items: center;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue